import { axios } from '@/utils/request'
import qs from 'qs'
let moduleName="holidayAdjust";

export function insert(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'post',
    data:parameter
  })
}
//撤销提交
export function getByIds(parameter) {
  console.log('data:', parameter)
  return axios({
    url: `/ws/${moduleName}/getByIds`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}
export function pageAll(parameter) {
  console.log('data:', parameter)
  return axios({
    url: `/ws/${moduleName}/pageAll`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}



export default {
  insert,
  getByIds,
  pageAll

}